import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

/* Mobile-only pill; hides while the sandbox (≥25%) or the footer is on screen. */
export const FloatingSandboxButton = () => {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const vis = { sandbox: false, footer: false };
    const apply = () => setHidden(vis.sandbox || vis.footer);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.target.id === "sandbox-preview") vis.sandbox = e.intersectionRatio >= 0.25; else vis.footer = e.isIntersecting; });
      apply();
    }, { threshold: [0, 0.25, 0.5] });
    const s = document.getElementById("sandbox-preview"), f = document.querySelector("[data-testid=landing-footer]");
    if (s) io.observe(s); if (f) io.observe(f);
    return () => io.disconnect();
  }, []);
  const go = () => document.getElementById("sandbox-preview")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <button type="button" className={`sbx-float md:hidden ${hidden ? "is-hidden" : ""}`} onClick={go} aria-hidden={hidden} tabIndex={hidden ? -1 : 0} data-testid="floating-sandbox-button" data-hidden={hidden ? "true" : "false"}>
      ⚡ Try the demo <ChevronDown size={18} className="sbx-float-chev" />
    </button>
  );
};
